exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.guestNamesFields .textField{width:100%;height:42px}[dir] .guestNamesFields .textField{border:1px solid #97999b}[dir=ltr] .guestNamesFields .textField,[dir=rtl] .guestNamesFields .textField{padding-left:10px;padding-right:10px}.guestNamesFields .inline-error{font-size:14px;line-height:16px;color:#c00;font-weight:700}[dir] .guestNamesFields .has-error{border:1px solid #c00}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/add-guests/add-guests.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/add-guests/add-guests.component.scss
// module chunks = 0